import React from 'react';
import DropdownButton from '../DropdownButton';
import InfoBubble from '../InfoBubble';
import InfoButtonIcon from '../InfoButtonIcon';

import styles from './styles.sass';

type Props = {
  direction: string;
  children?: React.ReactNode;
  width: number;
  activeOnHover?: boolean;
  infoBubbleClassName?: string;
  infoButtonIconClassName?: string;
};

// Info button that provides
const InfoButton = ({
  direction,
  children,
  width,
  activeOnHover,
  infoBubbleClassName = '',
  infoButtonIconClassName = '',
}: Props) => (
  <DropdownButton
    activeOnHover={!activeOnHover ? false : true}
    direction={direction}
    dropdownComponent={
      <InfoBubble
        positionAgainstParent={false}
        className={`${styles.bubble} ${infoBubbleClassName}`}
        direction={direction}
        width={width}
      >
        {children}
      </InfoBubble>
    }
  >
    <InfoButtonIcon className={infoButtonIconClassName} />
  </DropdownButton>
);

export default InfoButton;
